
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allproducts_list"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryAllproductsListWhereWhereConditions"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderby"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryAllproductsListOrderByOrderByClause"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expire"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"Kind"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allproducts_list"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderby"}}},{"kind":"Argument","name":{"kind":"Name","value":"expire"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expire"}}},{"kind":"Argument","name":{"kind":"Name","value":"Kind"},"value":{"kind":"Variable","name":{"kind":"Name","value":"Kind"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref0"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref1"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref4"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref5"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qte"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qte_stock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ref"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qte_max"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"gamme"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"comment"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stock"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cmd_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depot_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"depot_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"article_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"mvm_detail_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"create_uid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fournis_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"client_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_rcpt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_liv"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date_ret"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expire"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expire_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dispo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cmd_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"colis_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pmp"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fk_unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qte_rest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unit"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nbjour"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bag_need"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":810}};
    doc.loc.source = {"body":"query allproducts_list(\r\n  $where: QueryAllproductsListWhereWhereConditions\r\n  $orderby: [QueryAllproductsListOrderByOrderByClause!]\r\n  $expire: Int\r\n  $Kind: Int\r\n) {\r\n  allproducts_list(\r\n    where: $where\r\n    orderBy: $orderby\r\n    expire: $expire\r\n    Kind: $Kind\r\n  ) {\r\n    id\r\n    ref0\r\n    ref1\r\n    ref2\r\n    ref3\r\n    ref4\r\n    ref5\r\n    qte\r\n    qte_stock\r\n    code\r\n    ref\r\n    qte_max\r\n    gamme\r\n    comment\r\n    statut_id\r\n    statut\r\n    stock\r\n    label\r\n    cmd_name\r\n    depot_name\r\n    depot_id\r\n    article_id\r\n    mvm_detail_id\r\n    create_uid\r\n    fournis_name\r\n    client_name\r\n    date_rcpt\r\n    date_liv\r\n    date_ret\r\n    expire\r\n    expire_date\r\n    dispo\r\n    cmd_id\r\n    colis_id\r\n    pmp\r\n    fk_unit\r\n    qte_rest\r\n    statut_name\r\n    unit\r\n    nbjour\r\n    bag_need\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["allproducts_list"] = oneQuery(doc, "allproducts_list");
        
